<template>

    <footer class="footer container-fluid">

        <div class="row accordion-group">

            <div class="footer__contact">
                <img class="site-logo" v-if="contact.logo" :src="contact.logo.path" :alt="contact.logo.alt">
                <div class="footer__contact-info contact-info" v-if="contact">
                    <div class="accordion-container">
                        <button type="button" class="accordion-trigger preventScroll" aria-expanded="false" aria-controls="accordionContact" id="btnContact">
                            <h4 class="footer__contact-heading">
                                {{ contact.title }}
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
                            </h4>
                        </button>
                        <div class="accordion" role="region" id="accordionContact">
                            <a class="contact-info__address" v-html="contact.address" :href="contact.addressLink"></a>

                            <a class="contact-info__phone" :href="contact.phoneLink">{{ contact.phone }}</a>

                            <a class="contact-info__email" :href="contact.emailLink">{{ contact.email }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <nav class="footer__nav" aria-label="Footer Navigation">
                <!--Currently each accordion within an accordion group will close automatically if another is clicked.
                If this functionality is not needed a class of keep-open can be added to a accordion-container to prevent this-->
                <div class="accordion-container">
                    <button type="button" class="accordion-trigger" aria-expanded="false" aria-controls="accordionHelpfulLinks" id="btnHelpfulLinks">
                        <h4 class="footer__nav-heading">
                            Helpful Links
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>

                        </h4>
                    </button>
                    <div class="accordion" role="region" id="accordionHelpfulLinks">
                        <ul class="footer__nav-list">
                            <li class="footer__nav-item" :key="item.id" v-for="item in nav">
                                <a :href="item.linkURL">{{ item.linkText }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>

        <div class="social-links mobile-social" v-if="social">
            <ul class="social-links__list">
                <li class="social-links__item" :key="item.id" v-for="item in social">
                    <a :href="item.linkURL">
                        <img :src="item.icon" :alt="item.iconAlt">
                    </a>
                </li>
            </ul>
        </div>

        <div class="footer__legal" v-html="legal"></div>

    </footer>

</template>

<script>

    export default {
        name: 'Footer',
	
		props: ['contact', 'nav', 'social', 'legal']
    }

</script>